import Menu from '@/typings/classes/menu.class';

type State = { menusClasses: Menu[] };

const state: State = {
  menusClasses: [],
};

export { State, state };
